"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var multiple_image_choice_1 = __importDefault(require("./question/multiple-image-choice"));
var multiple_choice_1 = __importDefault(require("./question/multiple-choice"));
var essay_1 = __importDefault(require("./question/essay"));
var code_1 = __importDefault(require("./question/code"));
function questionToShow(question) {
    if (!question.currentQuestion)
        return;
    switch (question.currentQuestion.type) {
        case 'essay': {
            return React.createElement(essay_1["default"], { question: question });
        }
        case 'code': {
            return React.createElement(code_1["default"], { question: question });
        }
        case 'multiple-choice': {
            return React.createElement(multiple_choice_1["default"], { question: question });
        }
        case 'multiple-image-choice': {
            return React.createElement(multiple_image_choice_1["default"], { question: question });
        }
        default:
            return 'error: unexpected question type';
    }
}
exports["default"] = questionToShow;
